import React from 'react';

type PinterestIconProps = React.SVGProps<SVGSVGElement> & {
  weight?: 'regular' | 'fill' | 'bold' | 'light' | 'thin' | 'duotone';
};

export const PinterestIcon: React.FC<PinterestIconProps> = ({ className = '', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    className={className}
    {...props}
  >
    <circle cx="128" cy="128" r="128" fill="currentColor" />
    <path
      fill="#fff"
      d="M224,112c0,22.57-7.9,43.2-22.23,58.11C188.39,184,170.25,192,152,192c-17.88,0-29.82-5.86-37.43-12l-10.78,45.82A8,8,0,0,1,96,232a8.24,8.24,0,0,1-1.84-.21,8,8,0,0,1-6-9.62l32-136a8,8,0,0,1,15.58,3.66l-16.9,71.8C122,166,131.3,176,152,176c27.53,0,56-23.94,56-64A72,72,0,1,0,73.63,148a8,8,0,0,1-13.85,8A88,88,0,1,1,224,112Z"
    />
  </svg>
);

export default PinterestIcon;
